import { useSyncExternalStore } from "react"

import type { NavSectionId } from "./nav-items"

/**
 * Счётчики на пунктах навигации.
 *
 * ЧТО СЧИТАЕТСЯ. Только то, что ТРЕБУЕТ ДЕЙСТВИЯ (ТЗ §4.5): записи, ждущие подтверждения,
 * — но не все записи дня. Счётчик, который считает всё подряд, через неделю перестают
 * замечать, и тогда он перестаёт работать и для того единственного случая, ради которого
 * заводился.
 *
 * ТОЧКА ПОДКЛЮЧЕНИЯ: setNavBadge('journal', pendingCount) из экрана журнала, когда день
 * загружен. Пока никто ничего не сообщил, счётчиков нет — и это правильное состояние,
 * а не «ноль»: ноль утверждает, что подтверждать нечего, а мы этого ещё не знаем.
 */

export type NavBadges = Readonly<Partial<Record<NavSectionId, number>>>

let badges: NavBadges = {}
const listeners = new Set<() => void>()

function subscribe(listener: () => void): () => void {
  listeners.add(listener)
  return () => {
    listeners.delete(listener)
  }
}

function getSnapshot(): NavBadges {
  return badges
}

export function setNavBadge(id: NavSectionId, count: number | null): void {
  const next = count === null || count <= 0 ? undefined : count
  if (badges[id] === next) return
  const copy: Partial<Record<NavSectionId, number>> = { ...badges }
  if (next === undefined) delete copy[id]
  else copy[id] = next
  badges = copy
  for (const listener of listeners) listener()
}

export function useNavBadges(): NavBadges {
  return useSyncExternalStore(subscribe, getSnapshot, getSnapshot)
}
